<template>
    <div>
        <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="12">
                <el-radio-group v-model="tabPosition" @change="handleBtnChange">
                    <el-radio-button :label="`${curYear - 3}`">{{ curYear - 3 }}</el-radio-button>
                    <el-radio-button :label="`${curYear - 2}`">{{ curYear - 2 }}</el-radio-button>
                    <el-radio-button :label="`${curYear - 1}`">{{ curYear - 1 }}</el-radio-button>
                    <el-radio-button :label="`${curYear}`">{{ curYear }}</el-radio-button>
                </el-radio-group>
            </el-col>
        </el-row>
        <div style="text-align: center; margin: 20px 0px 10px 0px">
            <span v-text-lbl="'yearYk'" class="statistics_title" style="text-align: center" :curYear1="curYear1">{{ curYear1 }}年加油卡充值统计</span>
        </div>
        <div v-show="tableData.length" id="mychart" ref="mychart" class="mychart" />
        <el-row style="text-align: right; margin-bottom: 10px">
            <el-button v-if="show" :key="year" v-table-toxls="export_table" plain :file-name="filename">
                <svg-icon icon-class="export" />
                <span v-pageBtn-lbl="'export'">导出</span>
            </el-button>
        </el-row>
        <div class="table-wrap">
            <el-table id="export_table" ref="multipleTable" :data="tableData" border style="width: 100%" :span-method="arraySpanMethod" :cell-style="changeStyleHandler">
                <el-table-column :label="$tx('fields.index', '序号')" type="index" width="45" align="center" />
                <!-- <el-table-column
          :label="机构名称"
          width=""
          prop="orgName"
          align="left"
        /> -->
                <el-table-column :label="$tx('clgl.tjbb.JykTable.cardNumber', '加油卡号')" width="150" prop="cardNumber" align="left" />
                <el-table-column prop="1" :label="$tx('clgl.tjbb.JykTable.one', '1月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.one'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">1月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="2" :label="$tx('clgl.tjbb.JykTable.two', '2月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.two'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">2月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="3" :label="$tx('clgl.tjbb.JykTable.three', '3月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.three'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">3月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="4" :label="$tx('clgl.tjbb.JykTable.four', '4月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.four'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">4月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="5" :label="$tx('clgl.tjbb.JykTable.five', '5月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.five'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">5月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="6" :label="$tx('clgl.tjbb.JykTable.six', '6月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.six'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">6月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="7" :label="$tx('clgl.tjbb.JykTable.seven', '7月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.seven'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">7月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="8" :label="$tx('clgl.tjbb.JykTable.eight', '8月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.eight'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">8月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="9" :label="$tx('clgl.tjbb.JykTable.nine', '9月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.nine'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">9月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="10" :label="$tx('clgl.tjbb.JykTable.ten', '10月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.ten'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">10月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="11" :label="$tx('clgl.tjbb.JykTable.eleven', '11月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.eleven'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">11月</div>
                    </template>
                </el-table-column>
                <el-table-column prop="12" :label="$tx('clgl.tjbb.JykTable.twelve', '12月')" width="80" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.twelve'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">12月</div>
                    </template>
                </el-table-column>
                <el-table-column :label="$tx('clgl.tjbb.JykTable.total', '合计(元)')" width="120" prop="total" align="right">
                    <template slot="header">
                        <div v-text-lbl="'JykTable.total'" style="text-align: center; width: 100%; height: 28px; line-height: 35px">合计(元)</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
// import Bus from './bus.js'
import { mapGetters } from 'vuex'
import * as echarts from 'echarts'

export default {
    components: {},
    props: {},
    data() {
        return {
            i18npkg: 'clgl',
            moduleCode: 'tjbb',
            hiddenPageFlag: false,
            pageSize: 2,
            currentPage: 1,
            dataTotal: '',
            changeFlag: 'table',
            tabPosition: '',
            curYear: '',
            allData: [],
            tableData: [],
            tableData_m: [],
            listdata1: [],
            listdata2: [],
            listdata3: [],
            listdata4: [],
            allres: [],
            flag: false,
            curYear1: '',
            Num: {},
            loginUser: this.$store.getters.loginUser,
            filename: '',
            show: true
        }
    },
    computed: {
        ...mapGetters(['loginUser', 'routes'])
    },
    watch: {
        listdata(val) {
            this.trandClass()
        },
        curYear1(val) {
            this.show = false
            this.filename = this.$tx('clgl.tjbb.yearYk', { curYear1: val }, `${val}年加油卡充值统计`)
            this.$nextTick(() => {
                this.show = true
            })
        }
    },
    created() {
        const d = new Date()
        this.curYear = d.getFullYear()
        this.tabPosition = this.curYear
        this.curYear1 = this.curYear
        this.getdata()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        changeStyleHandler(row, index) {
            // console.log(row, index)
            if (row.rowIndex === this.tableData.length - 1 && row.columnIndex === 2) {
                return {
                    textAlign: 'center'
                }
            }
        },
        trandClass() {
            const table = document.querySelector('.el-table__footer')
            if (table !== null) {
                const trs = table.querySelectorAll('.has-gutter tr')
                if (trs.length > 0) {
                    trs.forEach((tr) => {
                        tr.className = 'el-table__row'
                    })
                }
            }
        },
        getSummaries(param) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    // sums[index] = '总价'
                    sums[index] = this.$tx('clgl.tjbb.totalPrice', '总价')
                    return
                }
                const values = data.map((item) => Number(item[column.property]))
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr)
                        if (!isNaN(value)) {
                            return prev + curr
                        } else {
                            return prev
                        }
                    }, 0)
                    sums[index] += '.00'
                } else {
                    sums[index] = ''
                }
            })
            sums[2] = ''
            return sums
        },
        // 图表
        changeToChart() {
            let listdataTmp = {}
            switch (parseInt(this.tabPosition)) {
                case parseInt(this.curYear):
                    listdataTmp = this.listdata1
                    break
                case parseInt(this.curYear) - 1:
                    listdataTmp = this.listdata2
                    break
                case parseInt(this.curYear) - 2:
                    listdataTmp = this.listdata3
                    break
                case parseInt(this.curYear) - 3:
                    listdataTmp = this.listdata4
                    break
                // default:
                //     listdataTmp = this.listdata1
            }

            const xdata = []
            const data = []
            listdataTmp.forEach((item) => {
                xdata.push(item.cardNumber)
                data.push(item.total)
            })
            this.$nextTick(() => {
                this.initCharts(xdata, data)
            })
        },
        initCharts(xdata, data) {
            // 基于准备好的dom，初始化echarts实例
            const myCharts = echarts.init(document.getElementById('mychart'))
            setTimeout(function () {
                window.onresize = function () {
                    myCharts.resize()
                }
            })
            // 绘制图表
            myCharts.setOption({
                tooltip: {},
                xAxis: {
                    name: '加油卡号',
                    nameTextStyle: {
                        fontSize: 12,
                        color: '#eeeee'
                    },
                    data: xdata,
                    // position: 'bottpm',
                    // nameLocation: 'middle',
                    // nameGap: 30,
                    // nameRotate: 0
                    align: 'end'
                },
                yAxis: {
                    name: this.curYear1 + '年充值费用（元）',
                    type: 'value',
                    nameTextStyle: {
                        fontSize: 12,
                        padding: [0, 0, 0, 120],
                        color: '#eeeee'
                    },
                    axisLabel: {
                        formatter: '{value}'
                    },
                    gridIndex: 0,
                    position: 'left',
                    nameLocation: 'end',
                    nameGap: 5,
                    nameRotate: 0,
                    axisLine: {
                        show: true
                    }
                },
                series: [
                    {
                        name: '加油卡充值费用',
                        type: 'bar',
                        data: data,
                        barWidth: 70,
                        itemStyle: {
                            normal: {
                                // 定义一个list，然后根据所以取得不同的值，这样就实现了，
                                color: function (params) {
                                    // build a color map as your need.
                                    // var colorList = [
                                    //     '#51A8FF'
                                    // ]
                                    // return colorList[params.dataIndex]
                                    return '#1E90FF'
                                }
                            }
                        }
                    }
                ],
                grid: {
                    left: '5%',
                    right: '6%',
                    top: '8%',
                    bottom: '8%'
                }
            })
        },
        handleBtnChange(v) {
            if (!v) {
                v = this.curYear
                this.changeToChart()
            }
            if (v !== 'undefined ' && v !== undefined) {
                this.curYear1 = v
            }
            console.log(this.curYear1, 'v')
            // this.$http({
            //     url: '/clgl/tjb/getJykczStatistics',
            //     method: 'POST',
            //     contentType: 'application/x-www-form-urlencoded',
            //     params: {
            //         'time': v
            //     }
            // }).then(res => {
            //     if (res.code === 'success') {
            // console.log(res.body.listdata)
            //     }
            // })
            const d = new Date()
            const curYear = d.getFullYear()
            if (parseInt(v) === this.curYear) {
                this.tableData = this.listdata1
                this.changeToChart()
            } else if (parseInt(v) === parseInt(curYear) - 1) {
                // console.log('vv:', v)
                this.tableData = this.listdata2
                this.changeToChart()
            } else if (parseInt(v) === curYear - 2) {
                this.tableData = this.listdata3
                this.changeToChart()
            } else if (parseInt(v) === curYear - 3) {
                this.tableData = this.listdata4
                this.changeToChart()
            }
            this.dataTotal = this.tableData.length
            this.tableData_m = this.tableData
            this.currentPage = 1
            // this.pageSize = 2
            // const startIndex = (this.currentPage - 1) * this.pageSize
            // const endIndex = (startIndex + this.pageSize)
            // if (this.tableData.length >= endIndex) {
            //     this.tableData = this.tableData.slice(startIndex, endIndex)
            // }
            // this.getdata()
            this.tableData.length > 0 ? this.changeToChart() : ''
            const copydata = JSON.parse(JSON.stringify(this.tableData))
            const lastrow = { cardNumber: this.$tx('clgl.tjbb.hj', '合计'), total: 0 }
            copydata.forEach((item) => {
                console.log(item)
                lastrow.total += Number(item.total)
            })
            lastrow.total = lastrow.total.toFixed(2)
            copydata.push(lastrow)
            this.tableData = copydata
            console.log(this.tableData)
        },
        arraySpanMethod(events) {
            if (events.rowIndex === this.tableData.length - 1) {
                if (events.columnIndex === 0) {
                    return [1, 0]
                } else if (events.columnIndex === 1) {
                    return [1, 2]
                } else if (events.columnIndex !== 14) {
                    return [1, 0]
                } else {
                    return [1, 12]
                }
            }
        },
        async getdata() {
            const param = {
                orderBy: 'carNumber asc',
                urlsearch: `orgCode:${this.loginUser.orgCode}`
            }
            const res = await this.$app.listdata('/clgl/jykcz/listdata', param)
            // this.$http({

            //     method: 'POST',
            //     url: '/clgl/jykcz/listdata',
            //     params: { orderBy: 'cardNumber asc' },
            //     data: [
            //         {
            //             'compare': '=',
            //             'field': 'orgCode',
            //             'merge': false,
            //             'value': this.loginUser.orgCode
            //         }
            //     ]
            // }).then(res => {
            // console.log(res)
            var numRmb = 0
            if (res.code === 'success') {
                this.allres = res.body.pageInfo.list
                this.allres.forEach((item) => {
                    console.log(item)
                    const item_tmp = {}
                    item_tmp.cardNumber = item.cardNumber
                    item_tmp.orgName = item.orgName
                    const d = new Date(item.rechargeDate)
                    item_tmp.year = parseInt(d.getFullYear())
                    item_tmp.month = parseInt(d.getMonth()) + 1
                    item_tmp.rechargeAmount = item.rechargeAmount
                    this.allData.push(item_tmp)
                    numRmb += item.rechargeAmount
                })
                // console.log('this.allData:', this.allData)
                this.allres.push({ cardNumber: this.$tx('clgl.tjbb.hj', '合计'), total: numRmb.toFixed(2) })
                this.allData.forEach((item2) => {
                    if (item2.year === this.curYear) {
                        if (this.listdata1 !== []) {
                            let flag = 0
                            this.listdata1.forEach((item11) => {
                                if (item11.cardNumber === item2.cardNumber) {
                                    flag = 1
                                    if (item11[item2.month]) {
                                        item11[item2.month] += parseInt(item2.rechargeAmount)
                                    } else {
                                        item11[item2.month] = parseInt(item2.rechargeAmount)
                                    }
                                }
                            })
                            if (flag === 0) {
                                const item_tmp = {}
                                item_tmp.cardNumber = item2.cardNumber
                                item_tmp.orgName = item2.orgName
                                item_tmp[item2.month] = parseInt(item2.rechargeAmount)
                                this.listdata1.push(item_tmp)
                            }
                        } else {
                            const item_tmp = {}
                            item_tmp.cardNumber = item2.cardNumber
                            item_tmp.orgName = item2.orgName
                            item_tmp[item2.month] = parseInt(item2.rechargeAmount)
                            this.listdata1.push(item_tmp)
                        }
                        this.listdata1.forEach((item) => {
                            item.total = 0
                            for (const key in item) {
                                if (parseInt(key) > 0 && parseInt(key) <= 12) {
                                    if (item[key] === '') {
                                        item[key] = 0
                                    }
                                    item.total += parseInt(item[key])
                                }
                            }
                            item.total = parseInt(item.total).toFixed(2)
                            for (let i = 1; i <= 12; i++) {
                                if (!item[i]) {
                                    item[i] = 0
                                }
                            }
                        })
                    } else if (item2.year === this.curYear - 1) {
                        if (this.listdata2 !== []) {
                            let flag = 0
                            this.listdata2.forEach((item22) => {
                                if (item22.cardNumber === item2.cardNumber) {
                                    flag = 1
                                    if (item22[item2.month]) {
                                        item22[item2.month] += parseInt(item2.rechargeAmount)
                                    } else {
                                        item22[item2.month] = parseInt(item2.rechargeAmount)
                                    }
                                }
                            })
                            if (flag === 0) {
                                const item_tmp = {}
                                item_tmp.cardNumber = item2.cardNumber
                                item_tmp.orgName = item2.orgName
                                item_tmp[item2.month] = parseInt(item2.rechargeAmount)
                                this.listdata2.push(item_tmp)
                            }
                        } else {
                            const item_tmp = {}
                            item_tmp.cardNumber = item2.cardNumber
                            item_tmp.orgName = item2.orgName
                            item_tmp[item2.month] = parseInt(item2.rechargeAmount)
                            this.listdata2.push(item_tmp)
                        }

                        this.listdata2.forEach((item) => {
                            item.total = 0
                            for (const key in item) {
                                if (parseInt(key) > 0 && parseInt(key) <= 12) {
                                    if (item[key] === '') {
                                        item[key] = 0
                                    }
                                    item.total = parseInt(item.total) + parseInt(item[key])
                                }
                            }
                            item.total = item.total.toFixed(2)
                            for (let i = 1; i <= 12; i++) {
                                if (!item[i]) {
                                    item[i] = 0
                                }
                            }
                        })
                    } else if (item2.year === this.curYear - 2) {
                        if (this.listdata3 !== []) {
                            let flag = 0
                            this.listdata3.forEach((item33) => {
                                if (item33.cardNumber === item2.cardNumber) {
                                    flag = 1
                                    if (item33[item2.month]) {
                                        item33[item2.month] += parseInt(item2.rechargeAmount)
                                    } else {
                                        item33[item2.month] = parseInt(item2.rechargeAmount)
                                    }
                                }
                            })
                            if (flag === 0) {
                                const item_tmp = {}
                                item_tmp.cardNumber = item2.cardNumber
                                item_tmp.orgName = item2.orgName
                                item_tmp[item2.month] = parseInt(item2.rechargeAmount)
                                this.listdata3.push(item_tmp)
                            }
                        } else {
                            const item_tmp = {}
                            item_tmp.cardNumber = item2.cardNumber
                            item_tmp.orgName = item2.orgName
                            item_tmp[item2.month] = parseInt(item2.rechargeAmount)
                            this.listdata3.push(item_tmp)
                        }

                        this.listdata3.forEach((item) => {
                            item.total = 0
                            for (const key in item) {
                                if (parseInt(key) > 0 && parseInt(key) <= 12) {
                                    if (item[key] === '') {
                                        item[key] = 0
                                    }
                                    item.total += parseInt(item[key])
                                }
                            }
                            item.total = item.total.toFixed(2)
                            for (let i = 1; i <= 12; i++) {
                                if (!item[i]) {
                                    item[i] = 0
                                }
                            }
                        })
                    } else if (item2.year === this.curYear - 3) {
                        if (this.listdata4 !== []) {
                            let flag = 0
                            this.listdata4.forEach((item44) => {
                                if (item44.cardNumber === item2.cardNumber) {
                                    flag = 1
                                    if (item44[item2.month]) {
                                        item44[item2.month] += parseInt(item2.rechargeAmount)
                                    } else {
                                        item44[item2.month] = parseInt(item2.rechargeAmount)
                                    }
                                }
                            })
                            if (flag === 0) {
                                const item_tmp = {}
                                item_tmp.cardNumber = item2.cardNumber
                                item_tmp.orgName = item2.orgName
                                item_tmp[item2.month] = parseInt(item2.rechargeAmount)
                                this.listdata4.push(item_tmp)
                            }
                        } else {
                            const item_tmp = {}
                            item_tmp.cardNumber = item2.cardNumber
                            item_tmp.orgName = item2.orgName
                            item_tmp[item2.month] = parseInt(item2.rechargeAmount)
                            this.listdata4.push(item_tmp)
                        }

                        this.listdata4.forEach((item) => {
                            item.total = 0
                            for (const key in item) {
                                if (parseInt(key) > 0 && parseInt(key) <= 12) {
                                    if (item[key] === '') {
                                        item[key] = 0
                                    }
                                    item.total += parseInt(item[key])
                                }
                            }
                            item.total = item.total.toFixed(2)
                            for (let i = 1; i <= 12; i++) {
                                if (!item[i]) {
                                    item[i] = 0
                                }
                            }
                        })
                    }
                })
                this.listdata1.forEach((item) => {
                    for (let i = 1; i <= 12; i++) {
                        if (!item[i]) {
                            item[i] = Number(0).toFixed(2)
                        } else {
                            item[i] = parseInt(item[i]).toFixed(2)
                        }
                    }
                })
                this.listdata2.forEach((item) => {
                    for (let i = 1; i <= 12; i++) {
                        if (!item[i]) {
                            item[i] = Number(0).toFixed(2)
                        } else {
                            item[i] = parseInt(item[i]).toFixed(2)
                        }
                    }
                })
                this.listdata3.forEach((item) => {
                    for (let i = 1; i <= 12; i++) {
                        if (!item[i]) {
                            item[i] = Number(0).toFixed(2)
                        } else {
                            item[i] = parseInt(item[i]).toFixed(2)
                        }
                    }
                })
                this.listdata4.forEach((item) => {
                    for (let i = 1; i <= 12; i++) {
                        if (!item[i]) {
                            item[i] = Number(0).toFixed(2)
                        } else {
                            item[i] = parseInt(item[i]).toFixed(2)
                        }
                    }
                })
                if (!this.flag) {
                    this.flag = true
                    this.handleBtnChange()
                }
            }
            // })
        }
    }
}
</script>

<style scoped lang="scss">
.mychart {
    //  width: 1805px;
    width: 88vw;
    height: 300px;
    // border:1px solid red
    margin: 0 auto;
    margin: 0px 0px 20px -8px;
}
.table-wrap {
    width: 100%;
}
/deep/ .el-table__header {
    width: 100% !important;
}
/deep/ .el-table__body {
    width: 100% !important;
}
/deep/ .el-table .cell {
    text-align: center;
}
</style>
